import React from "react";
import { useNavigate } from "react-router-dom";
import { AuthService } from "../services/auth.service";
import MainLayout from "../components/layouts/MainLayout";

export const DrugPriorAuthPage: React.FC = () => {
  const navigate = useNavigate();
  const user = AuthService.getCurrentUser();

  if (!user) {
    navigate("/");
    return null;
  }

  return (
    <MainLayout>
      {/* Main Content */}
      <main className="flex-1 min-w-0 relative md:ml-0 ml-12">
        <div className="flex items-center justify-center min-h-[calc(100vh-4rem)]">
          <div className="text-center p-8">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Coming Soon</h2>
            <p className="text-xl text-gray-600">
              Prior Authorization feature is currently under development
            </p>
          </div>
        </div>
      </main>
    </MainLayout>
  );
};
